import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddCheckItemTemplate } from '../../../models/forms/ICheckItemTemplate';
import { IFormModalProps } from '../../../models/forms/IForm';
import { AddCheckItemTemplateInitialState } from '../../../core/initialState/add-edit-check-item-template-state';
import AddEditCheckItemTemplateForm from '../forms/add-edit-check-item-form';

const AddEditCheckItemTemplate = (props: IFormModalProps) => {
  const { processStore, checkItemTemplateStore } = useStore();
  const { allProcessReactSelectOptions, GetAllProcessService } = processStore;
  const {
    AddCheckItemTemplateService,
    UpdateCheckItemTemplateService,
    GetCheckItemTemplateByIdService,
    checkItemTemplateDetail,
  } = checkItemTemplateStore;

  const tenantId = Number(getTenantIdFromLocalStorage());

  useEffect(() => {
    GetAllProcessService();
    if (props.id > 0) {
      GetCheckItemTemplateByIdService(tenantId, props.id);
    } else {
      checkItemTemplateStore.resetDetail();
    }
  }, [props.id]);

  const onSubmitForm = (values: IAddCheckItemTemplate) => {
    // console.log('Values triggered on save/update (container):', values);
    if (props.id === -1) {
      AddCheckItemTemplateService(values);
    } else {
      UpdateCheckItemTemplateService(values);
    }
  };

  return (
    <AddEditCheckItemTemplateForm
      initialValues={
        props.id > 0
          ? checkItemTemplateDetail
          : AddCheckItemTemplateInitialState
      }
      id={props.id}
      submitHandler={onSubmitForm}
      onModalClosed={props.modalClosed}
      isLoading={
        checkItemTemplateStore.addUpdateCheckItemTemplateState.inProgress ||
        checkItemTemplateStore.getCheckItemTemplateByIdState.inProgress
      }
      allProcessOptions={allProcessReactSelectOptions}
    />
  );
};

export default observer(AddEditCheckItemTemplate);
